import React from 'react';

import {
  FILTER_RANGE_INPUT,
  FILTER_TYPE_REFINEMENT_LIST,
  LISTING_SEARCH_ID,
  PRICE_AMOUNT_FILTER,
} from '../../../constants';
import { FormattedMessage } from '../../../util/reactIntl';
import CustomRefinementList from './RefinementList';
import CustomRangeInput from './RangeFilter';
import { Button } from '../../../components';
import { useClearRefinements, useRange } from 'react-instantsearch';
import { createResourceLocatorString } from '../../../util/routes';
import css from './Filters.module.css';

const Filters = ({
  intl,
  filters,
  routeConfiguration,
  history,
  queryParams,
}) => {
  if (!filters || filters.length === 0) {
    console.warn('No filters provided');
    return null;
  }

  const { canRefine: canClear, refine: clearRefine } = useClearRefinements();
  const { refine: clearRange } = useRange({
    attribute: PRICE_AMOUNT_FILTER,
    precision: 2,
  });

  return (
    <div>
      {filters.map((filter, index) => {
        const { type, attribute, label } = filter;

        // Ensure necessary properties exist before rendering
        if (!type || !attribute) {
          console.warn('Invalid filter configuration:', filter);
          return null;
        }

        // Render based on filter type
        switch (type) {
          case FILTER_TYPE_REFINEMENT_LIST:
            return (
              <CustomRefinementList
                key={`${attribute}-${index}`}
                attribute={attribute}
                label={label}
                intl={intl}
                history={history}
                routes={routeConfiguration}
                queryParams={queryParams}
              />
            );

          case FILTER_RANGE_INPUT:
            return (
              <CustomRangeInput
                key={`${attribute}-${index}`}
                attribute={attribute}
                precision={2}
                intl={intl}
                history={history}
                routes={routeConfiguration}
                queryParams={queryParams}
              />
            );

          default:
            console.warn(`Unsupported filter type: ${type}`);
            return null;
        }
      })}

        <Button
          // disabled={!canClear}
          className={css.clearButton}
          onClick={() => {
            clearRange();
            history.push(
              createResourceLocatorString('SearchPage', routeConfiguration, {})
            );
            // clearRefine()
          }}
        >
          <FormattedMessage id="SearchPageFilters.resetAll" />
        </Button>

    </div>
  );
};
export default Filters;
